<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-spacer />
              <v-col
                cols="12"
                md="3"
                xl="2"
              >
                <v-autocomplete
                  v-model="yearFilter"
                  clearable
                  :items="years"
                  label="Year Filter"
                  placeholder="Filter by year"
                />
              </v-col>

              <v-col
                v-if="$hasPermissionTo(['copy tax relief'])"
                cols="12"
                md="2"
                xl="2"
              >
                <payroll-setup-tax-reliefs-dialog-copy
                  :available-years="years"
                  @created="handleDetailCopied"
                /> 
              </v-col>
            </v-row>
          </v-card-actions>

          <v-data-table
            :headers="headers"
            :loading="tableLoading"
            :search="search"
            :items="filteredTaxRelief"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <span>
                  {{ (item.name) }}
                </span>
              </div>
            </template>

            <template v-slot:item.amount="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.amount) }}  
                </span>
              </div>
            </template>

            <template v-slot:item.action="{ item }">
              <payroll-setup-tax-reliefs-dialog-edit 
                v-if="$hasPermissionTo(['update tax relief'])"
                :tax-relief="item"
                @updated="loadTaxRelief"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <span class="subtitle-2 font-weight-medium font-italic">
      <div>
        <span class="font-weight-bold">Legend: </span>
        <span class="font-weight-bold">Category 1</span> = Single, 
        <span class="font-weight-bold">Category 2</span> = Married & Spouse is not working, 
        <span class="font-weight-bold">Category 3</span> = Married and Spouse is working, 
      </div>
    </span>
  </v-container>
</template>

<script>
  export default {
    components: {
      PayrollSetupTaxReliefsDialogCopy: () => import('@/components/payroll/setup/taxReliefs/DialogCopy'), 
      PayrollSetupTaxReliefsDialogEdit: () => import('@/components/payroll/setup/taxReliefs/DialogEdit'),
    },
  
    data () {
      return {
        tableLoading: false,
        yearFilter: (new Date()).getFullYear(),
        years: [],   
        search: '',
        taxReliefs: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
            sortable: false,
          },
          {
            text: 'Amount(RM)',
            align: 'right',
            value: 'amount',
            sortable: false,
          },
          {
            text: '',
            value: 'action',
            align: 'center',
            sortable: false,
          },
        ],
      }
    },
    computed: {
      filteredTaxRelief () {
        return this.taxReliefs.filter(taxRelief => taxRelief.year === this.yearFilter)
      },
    },
    created () {
      this.loadTaxRelief()
    },  
    methods: {     
      loadTaxRelief () {
        this.tableLoading = true

        Promise.all([
          this.$api.taxRelief().listTaxReliefYear(),
          this.$api.taxRelief().list(),
        ])
          .then(([year, taxRelief]) => {
            this.years = year.data 
            this.taxReliefs = _.orderBy(taxRelief.data, ['amount'], ['asc'])      

            this.tableLoading = false
          })
      },

      currencyFormatting (item) {
        return (Math.round((item / 100) * 100) / 100).toFixed(2)
      },

      handleDetailCopied (year) {
        this.setYearFilter(year)
        this.loadTaxRelief()
      },
      setYearFilter (year) {
        this.yearFilter = year
      },     
    },
  }
</script>
